import React from 'react';
import MainApp from "./MainApp";

function App() {
  return (
    <MainApp />
  );
}

export default App;
